export const environment = {
  baseApiUrl: 'https://de-colgate-prod.azurewebsites.net/',
  redirectUrl: 'https://explorerplus-cp-apac-northstar-prod.kantar.com/landing',
  kantarClientID: '0904b804-9b0b-46eb-9a58-1e4c8f22fa7f',
  kantarApiClientID: '480af3ff-1795-4d29-8632-e6aec2b0ae93',
  kantarAuthorityID: 'https://login.microsoftonline.com/1e355c04-e0a4-42ed-8e2d-7351591f0ef1',
  UserGuideUrl: 'https://elearning.easygenerator.com/bcd568f0-29e3-43fb-a042-238bfbb04e6e/',
  UserGuideSnapshotUrl: 'https://elearning.easygenerator.com/4168a9e6-5f42-4a18-80cd-5aeab0add565/',
  logoutURL: 'https://explorerplus-cp-apac-northstar-prod.kantar.com/signout-oidc',
  sessionTimeOut: '60',
  env: 'dev',
  showUploadModule: 'true',
  askMePythonUrl: 'https://askmepythonapi-atcphegjdudxbsav.northeurope-01.azurewebsites.net/',
  dedicatedCss: 'false',
};
